// Formatos de la Torre compartidos entre pantallas y descargas.
const pesos = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export function formatPesos(amount: number): string {
  return pesos.format(amount);
}

export function formatCents(cents: number): string {
  return formatPesos(cents / 100);
}

export function plural(count: number, singular: string, pluralForm = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : pluralForm}`;
}

export const MANAGEMENT_LABELS = { exchange: "Cambio", pickup: "Retiro" } as const;

// Clave de búsqueda: mayúsculas, sin acentos ni signos. Se aplica a la consulta
// y al texto buscado, así "san martín" encuentra "SAN MARTIN".
export function searchKey(value: string | null | undefined): string {
  return String(value || "")
    .toLocaleUpperCase("es")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9]+/g, " ")
    .trim();
}

// Minutos como "1 h 5 min" o "45 min".
export function formatMinutes(minutes: number): string {
  return minutes >= 60 ? `${Math.floor(minutes / 60)} h ${minutes % 60} min` : `${minutes} min`;
}

// Tipo de envío: Flex (amarillo), Particular (violeta) o sin clasificar (gris),
// cuando el origen no alcanza para decidir.
export function universeLabel(universe: string): string {
  return universe === "FLEX" ? "Flex" : universe === "NON_FLEX" ? "Particular" : "Sin clasificar";
}

export function universeClass(universe: string): string {
  return universe === "FLEX" ? "flex" : universe === "NON_FLEX" ? "particular" : "";
}

// Distancia legible: metros debajo de 1 km.
export function formatKm(km: number | null) {
  if (km === null) return "Sin coordenadas";
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}
